import Constants from '~/utils/constants';

export enum ApiMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}
interface FetchApiDataParams<T> {
  url: string;
  method?: ApiMethod;
  body?: Record<string, any>;
  headers?: HeadersInit_;
  tryNewWay?: boolean;
  reqParamsURL?: Record<string, string | number>;
  authHeaders?: {
    tokenBearer?: string;
    id?: string;
    sessionId?: string;
    ipAddress?: string;
    deviceId?: string;
  };
}
export async function httpRequest<T>({
  url,
  method = ApiMethod.GET,
  body = {},
  headers = {},
  tryNewWay = false,
  reqParamsURL,
  authHeaders,
}: FetchApiDataParams<T>): Promise<{
  status: number;
  data: T | null;
  response: Response | null;
  mensagem?: string;
  message?: string;
  error?: string;
  success?: boolean;
  headers?: Headers;
}> {
  const startTime = performance.now();
  let responseCopy: Response | null = null;
  let data: any = null;
  let newUrl = url;
  console.groupCollapsed(`STARTING - [fetchApiData] - ${newUrl}`);
  console.log('URL:', newUrl);
  console.log('Method:', method);
  console.log('Body:', body);
  console.groupEnd();
  try {
    const reqHeaders: Headers = new Headers();
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    const tokenBearer = localStorage.getItem(Constants.TOKEN_BEARER);
    const ipAdress = localStorage.getItem(Constants.IP_ADRESS);
    const { userAgent } = navigator;
    const sessionId = localStorage.getItem(Constants.SESSION_ID);
    const xCode = localStorage.getItem(Constants.X_CODE);
    const idOperator = localStorage.getItem(Constants.USER_ID);
    const tokenReCaptcha = sessionStorage.getItem(Constants.TOKEN_RECAPTCHA);

    if (sessionId) reqHeaders.set('Id-Sessao', sessionId);
    reqHeaders.set('Id-Sistema', `${process.env.REACT_APP_ID_SISTEMA}`);
    if (userAgent) reqHeaders.set('User-Agent', userAgent);
    if (xCode) reqHeaders.set('X-Code', xCode);
    if (ipAdress) reqHeaders.set('X-Sent-By', ipAdress);
    if (idOperator) reqHeaders.set('Id-User', idOperator);
    reqHeaders.set('Content-Type', 'application/json');
    if (token) reqHeaders.set('apikey', `token ${token}`);
    if (tokenBearer) reqHeaders.set('Authorization', `Bearer ${tokenBearer}`);
    if (tokenReCaptcha) reqHeaders.set('ReCaptcha-Token', tokenReCaptcha);

    reqHeaders.set('Content-Type', 'application/json');

    if (headers) Object.assign(reqHeaders, headers);

    let requestBody = body;
    if (!Array.isArray(body)) {
      requestBody = { ...body };
    }

    const options: RequestInit = {
      method,
      headers: reqHeaders,
      ...(method !== ApiMethod.GET && {
        body: JSON.stringify(requestBody),
      }),
    };

    if (method === ApiMethod.GET && tryNewWay) {
      Object.keys(requestBody).forEach((key) => {
        if (
          requestBody[key] === '' ||
          requestBody[key] === undefined ||
          requestBody[key] === null
        ) {
          delete requestBody[key];
        }
      });
      const query = new URLSearchParams(requestBody).toString();

      if (reqParamsURL) {
        Object.entries(reqParamsURL).forEach(([key, value]) => {
          newUrl = newUrl.replace(key, value?.toString());
        });
      }

      newUrl = query?.length ? `${newUrl}?${query}` : newUrl;
    } else if (reqParamsURL) {
      Object.entries(reqParamsURL).forEach(([key, value]) => {
        newUrl = newUrl.replace(key, value?.toString());
      });
    }

    const response = await fetch(newUrl, options);
    responseCopy = response.clone();

    const contentType = response.headers.get('content-type');
    if (contentType?.includes('application/json')) {
      data = await response.json();
    } else if (
      contentType?.includes('text/csv') ||
      contentType?.includes('application/vnd.ms-excel')
    ) {
      data = await response.blob();
    }

    if (response.status === 403) {
      throw new Error('Você não possui permissão para prosseguir.');
    }

    const endTime = performance.now();
    console.groupCollapsed(`[fetchApiData] - ${newUrl}`);
    console.log('URL:', newUrl);
    console.log('Method:', method);
    console.log('Body:', requestBody);
    console.log('Response:', data);
    console.log('Status:', response.status);
    console.log('Time spent (ms):', (endTime - startTime).toFixed(2));
    console.groupEnd();
    if (!response.ok) {
      throw new Error(data?.mensagem || 'Houve um error');
    }
    return {
      status: response.status,
      data,
      response,
      success: response.ok,
      mensagem: data?.mensagem,
      message: data?.mensagem,
      error: response.ok ? null : data?.mensagem || 'Erro desconhecido',
      headers: responseCopy.headers,
    };
  } catch (error: any) {
    const endTime = performance.now();
    console.groupCollapsed(`[fetchApiData] - ${newUrl} [ERROR]`);
    console.log('Error:', error);
    console.log('Error message:', error.message);
    console.log('Time spent (ms):', (endTime - startTime).toFixed(2));
    console.groupEnd();
    return {
      status: responseCopy?.status ?? 0,
      data: data,
      response: null,
      mensagem: error.message,
      message: error.message,
      error: error.message,
      success: false,
      headers: responseCopy?.headers,
    };
  }
}
